import { render, staticRenderFns } from "./SubmitPosition.vue?vue&type=template&id=3a2e2b3b&scoped=true"
import script from "./SubmitPosition.vue?vue&type=script&lang=js"
export * from "./SubmitPosition.vue?vue&type=script&lang=js"
import style0 from "./SubmitPosition.vue?vue&type=style&index=0&id=3a2e2b3b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a2e2b3b",
  null
  
)

export default component.exports